export const categoryFilters = ['bedroom', 'priceRange'];
